module.exports = __webpack_public_path__ + "img/9788996373735.c0e95c1f.jpg";